export class Login {

  id: number;
  username:string;
  version:number = 0;
  accountExpired:boolean = false;
  accountLocked:boolean =false;
  enabled:boolean = false;
  passwordExpired:boolean = false;
  verified:boolean = false;
  resetKey:string = "";
  verifyKey:string= "";
  password:string="";
  token:string="";
}



// WEBPACK FOOTER //
// ./src/app/shared/Login.ts